/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Statut } from './Statut';
import {
    StatutFromJSON,
    StatutFromJSONTyped,
    StatutToJSON,
    StatutToJSONTyped,
} from './Statut';

/**
 * A validation request in the validator inbox.
 * @export
 * @interface DemandeValidationListItemDto
 */
export interface DemandeValidationListItemDto {
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    id: string;
    /**
     * 
     * @type {Statut}
     * @memberof DemandeValidationListItemDto
     */
    statut: Statut;
    /**
     * 
     * @type {Date}
     * @memberof DemandeValidationListItemDto
     */
    dateDemande: Date;
    /**
     * 
     * @type {Date}
     * @memberof DemandeValidationListItemDto
     */
    dateReponse?: Date | null;
    /**
     * Name of the validator who answered, null while pending.
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    traiteePar?: string | null;
    /**
     * The current user is the validator who answered.
     * @type {boolean}
     * @memberof DemandeValidationListItemDto
     */
    traiteeParMoi: boolean;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    devisId: string;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    identifiantDevis?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    identifiantDossier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    codeBranche?: string | null;
    /**
     * Product label.
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    produit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    tunnelId: string;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    tunnelDesignation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    courtierId: string;
    /**
     * Brokerage firm of the quote.
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    courtierNom?: string | null;
    /**
     * Collaborator who sent the request.
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    demandeePar?: string | null;
    /**
     * Platform of the quote.
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    plateformeNom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeValidationListItemDto
     */
    souscripteur?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DemandeValidationListItemDto
     */
    prixClient: number;
}



/**
 * Check if a given object implements the DemandeValidationListItemDto interface.
 */
export function instanceOfDemandeValidationListItemDto(value: object): value is DemandeValidationListItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('statut' in value) || value['statut'] === undefined) return false;
    if (!('dateDemande' in value) || value['dateDemande'] === undefined) return false;
    if (!('traiteeParMoi' in value) || value['traiteeParMoi'] === undefined) return false;
    if (!('devisId' in value) || value['devisId'] === undefined) return false;
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    if (!('courtierId' in value) || value['courtierId'] === undefined) return false;
    if (!('prixClient' in value) || value['prixClient'] === undefined) return false;
    return true;
}

export function DemandeValidationListItemDtoFromJSON(json: any): DemandeValidationListItemDto {
    return DemandeValidationListItemDtoFromJSONTyped(json, false);
}

export function DemandeValidationListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeValidationListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'statut': StatutFromJSON(json['statut']),
        'dateDemande': (new Date(json['dateDemande'])),
        'dateReponse': json['dateReponse'] == null ? undefined : (new Date(json['dateReponse'])),
        'traiteePar': json['traiteePar'] == null ? undefined : json['traiteePar'],
        'traiteeParMoi': json['traiteeParMoi'],
        'devisId': json['devisId'],
        'identifiantDevis': json['identifiantDevis'] == null ? undefined : json['identifiantDevis'],
        'identifiantDossier': json['identifiantDossier'] == null ? undefined : json['identifiantDossier'],
        'codeBranche': json['codeBranche'] == null ? undefined : json['codeBranche'],
        'produit': json['produit'] == null ? undefined : json['produit'],
        'tunnelId': json['tunnelId'],
        'tunnelDesignation': json['tunnelDesignation'] == null ? undefined : json['tunnelDesignation'],
        'courtierId': json['courtierId'],
        'courtierNom': json['courtierNom'] == null ? undefined : json['courtierNom'],
        'demandeePar': json['demandeePar'] == null ? undefined : json['demandeePar'],
        'plateformeNom': json['plateformeNom'] == null ? undefined : json['plateformeNom'],
        'souscripteur': json['souscripteur'] == null ? undefined : json['souscripteur'],
        'prixClient': json['prixClient'],
    };
}

export function DemandeValidationListItemDtoToJSON(json: any): DemandeValidationListItemDto {
    return DemandeValidationListItemDtoToJSONTyped(json, false);
}

export function DemandeValidationListItemDtoToJSONTyped(value?: DemandeValidationListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'statut': StatutToJSON(value['statut']),
        'dateDemande': ((value['dateDemande']).toISOString()),
        'dateReponse': value['dateReponse'] == null ? undefined : ((value['dateReponse'] as any).toISOString()),
        'traiteePar': value['traiteePar'],
        'traiteeParMoi': value['traiteeParMoi'],
        'devisId': value['devisId'],
        'identifiantDevis': value['identifiantDevis'],
        'identifiantDossier': value['identifiantDossier'],
        'codeBranche': value['codeBranche'],
        'produit': value['produit'],
        'tunnelId': value['tunnelId'],
        'tunnelDesignation': value['tunnelDesignation'],
        'courtierId': value['courtierId'],
        'courtierNom': value['courtierNom'],
        'demandeePar': value['demandeePar'],
        'plateformeNom': value['plateformeNom'],
        'souscripteur': value['souscripteur'],
        'prixClient': value['prixClient'],
    };
}

